import { faker } from '@faker-js/faker';
import { Measurement } from '@dynamika-shared/types/measurements';

export function createRandomMeasurement(id = faker.string.uuid()): Measurement {
  return {
    id,
    index: faker.number.int(100),
    instrumentId: faker.string.uuid(),
    instrumentStateJson: {
      annotation: {},
      measurementState: {},
    },
    instrumentStateText: faker.lorem.sentence(),
    locked: false,
    measurementLabelId: faker.string.uuid(),
    screenshotIds: [],
    measurementData: {
      data: {},
      isNA: false,
    },
    measurementId: faker.string.uuid(),
    measurementName: faker.company.name(),
    permanent: false,
    status: faker.helpers.arrayElement([
      'CREATED',
      'SCREENSHOT_PENDING',
      'COMPLETED',
    ]),
  };
}

export function createRandomMeasurementList(count: number): Measurement[] {
  return faker.helpers.multiple(createRandomMeasurement, { count });
}
